import type { PaginatedEventsResponse } from '@/api/services/event-cards-service';
import { withBasePath } from '@/utils/withBasePath';

export type EventsFromDateOrder = 'start_asc' | 'start_desc';

interface EventsFromDateResponse {
  events: PaginatedEventsResponse['events'];
  page: number;
  page_size: number;
  has_more: boolean;
}

export async function fetchOrganizerEventsFromDate(
  organizerId: string,
  fromDate: string,
  page: number,
  pageSize: number,
  orderBy: EventsFromDateOrder,
  includeStarted = false,
): Promise<PaginatedEventsResponse> {
  const params = new URLSearchParams({
    from_date: fromDate,
    page: String(page),
    page_size: String(pageSize),
    order_by: orderBy,
    include_started: String(includeStarted),
  });
  const res = await fetch(
    withBasePath(`/api/organizers/${organizerId}/events-from-date/?${params}`),
    {
      credentials: 'include',
    },
  );

  if (!res.ok) {
    throw new Error(`Events from date request failed: ${res.status}`);
  }

  const data = (await res.json()) as EventsFromDateResponse;

  return {
    events: data.events ?? [],
    hasMore: data.has_more,
    total: data.events?.length ?? 0,
  };
}
